export default __webpack_public_path__ + "static/ehm-hair-repair-bfb86dcf099e613870b189b141c096e0.png";